module.exports = __webpack_public_path__ + "static/media/empty-demo.22bf5e84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/empty-demo.svg
// module id = ./src/common/assets/empty-demo.svg
// module chunks = 18